export default __webpack_public_path__ + "static/media/History.cffae51a.gif";